import { render, staticRenderFns } from "./OfferMailComposer.vue?vue&type=template&id=dbb6cf54"
import script from "./OfferMailComposer.vue?vue&type=script&lang=js"
export * from "./OfferMailComposer.vue?vue&type=script&lang=js"
import style0 from "./OfferMailComposer.vue?vue&type=style&index=0&id=dbb6cf54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports